import httpClient from "./httpClient";

const notificationService = {
  updateStoreUserInfo(body) {
    return httpClient.post('/api/notification/users/info', body);
  },
  getFrontendTechs(){
    return httpClient.get(`api/frontend-tech`);
  },
 getNumberCountNotiInApp(params){
    return httpClient.get('/api/v2/notification/in-app/count', {params: params});
  },
  getNotificationsInApp(params){
    return httpClient.get('/api/v2/notification/in-app', {params: params});
  },
  logUnreadNotification(body) {
    return httpClient.post('/api/v2/notification/in-app/status', body);
  },
  getRichTextDetail(idNotificationSent ,params) {
    return httpClient.get(`/api/v2/notification/rich-text/${idNotificationSent}`, {params: params});

  },
  getNoticonfig() {
    return httpClient.get('/api/v2/notification/configurations');

  },
 
}

export default notificationService;
